export const isNonTransactional = false

export const showPriceshowPriceTransactional = false